/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
// import auth from "@/auth/authService";
import axios from "@/axios.js"

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () =>
                import ('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                // {
                //     path: '/',
                //     name: 'home',
                //     meta: {
                //         name: "Kezdőlap"
                //     },
                //     component: () =>
                //         import ('./views/Home.vue')
                // },
                {
                    path: '/ugyletek',
                    name: 'ugyletek',
                    meta: {
                        name: "Ügyletek"
                    },
                    component: () =>
                        import ('./views/transactions/TransactionList.vue')
                },
                {
                    path: '/ugylet/:id',
                    name: 'ugylet',
                    meta: {
                        name: "Ügylet"
                    },
                    component: () =>
                        import ('./views/transactions/TransactionEdit.vue')
                },
                {
                    path: '/ugyletek/uj',
                    name: 'ugyletek/uj',
                    meta: {
                        name: "Új ügylet"
                    },
                    component: () =>
                        import ('./views/transactions/TransactionAdd.vue')
                },
                {
                    path: '/dolgozok',
                    name: 'dolgozok',
                    meta: {
                        name: "Dolgozók",
                        onlyAdmin: true
                    },
                    component: () =>
                        import ('./views/workers/WorkerList.vue')
                },
                {
                    path: '/megrendelok',
                    name: 'megrendelok',
                    meta: {
                        name: "Megrendelők"
                    },
                    component: () =>
                        import ('./views/customers/CustomerList.vue')
                },
                {
                    path: '/megrendelok/uj',
                    name: 'megrendelok/uj',
                    meta: {
                        name: "Új megrendelő"
                    },
                    component: () =>
                        import ('./views/customers/CustomerEdit.vue')
                },
                {
                    path: '/megrendelo/:id',
                    name: 'megrendelo',
                    meta: {
                        name: "Megrendelő"
                    },
                    component: () =>
                        import ('./views/customers/CustomerEdit.vue')
                },
                {
                    path: '/akadalyok',
                    name: 'akadalyok',
                    meta: {
                        name: "Akadályok",
                        onlyAdmin: true
                    },
                    component: () =>
                        import ('./views/obstacles/ObstacleList.vue')
                },
                {
                    path: '/ingatlan-tipusok',
                    name: ' ingatlan-tipusok',
                    meta: {
                        name: "Ingatlan típusok",
                        onlyAdmin: true
                    },
                    component: () =>
                        import ('./views/property-types/PropertyTypeList.vue')
                },
                {
                    path: '/ugylet-tipusok/:id',
                    name: 'ugylet-tipusok',
                    meta: {
                        name: "Ügylet típus"
                    },
                    component: () =>
                        import ('./views/transaction-types/TransactionTypeEdit.vue')
                },
                {
                    path: '/ugylet-tipusok',
                    name: ' ugylet-tipusok',
                    meta: {
                        name: "Ügylet típusok",
                        onlyAdmin: true
                    },
                    component: () =>
                        import ('./views/transaction-types/TransactionTypeList.vue')
                },
                {
                    path: '/profil',
                    name: ' profil',
                    meta: {
                        name: "Profil",
                        onlyAdmin: true
                    },
                    component: () =>
                        import ('./views/profile/UserSettings.vue')
                },
                {
                    path: '/statisztika',
                    name: ' statisztika',
                    meta: {
                        name: "Statisztika",
                        onlyAdmin: true
                    },
                    component: () =>
                        import ('./views/statistics/Statistics.vue')
                },
            ],
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () =>
                import ('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/login',
                    name: 'login',
                    component: () =>
                        import ('@/views/pages/Login.vue'),
                    meta: {
                        noAuthRequired: true
                    }
                },
                {
                    path: '/elfelejtett-jelszo',
                    name: 'elfelejtett-jelszo',
                    component: () =>
                        import ('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        noAuthRequired: true
                    }
                },
                {
                    path: '/reset-password/:token',
                    name: 'reset-password',
                    component: () =>
                        import ('@/views/pages/ResetPassword.vue'),
                    meta: {
                        noAuthRequired: true
                    }
                },
                {
                    path: '/set-password/:token',
                    name: 'set-password',
                    component: () =>
                        import ('@/views/pages/SetPassword.vue'),
                    meta: {
                        noAuthRequired: true
                    }
                },
                {
                    path: '/404',
                    name: 'page-error-404',
                    component: () =>
                        import ('@/views/pages/Error404.vue'),
                    meta: {
                        noAuthRequired: true
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/404'
        }
    ],
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
    // If auth required, check login. If login fails redirect to login page
    if (!to.meta.noAuthRequired) {

        if (!localStorage.getItem('accessToken')) {
            router.push({ path: '/login', query: { to: to.path } })
        }

        if (from.name == 'ugylet') {
            axios.post("/api/transactions/unlock", { transactionId: from.params.id })
                .then(() => {
                    localStorage.removeItem('locked');
                    window.clearInterval()
                })
                .catch((error) => {
                    console.log(error);
                })
        }



        axios.post('/api/auth/check/')
            .then((response) => {
                localStorage.setItem('role', response.data.userData.userRole)
                localStorage.setItem("userInfo", JSON.stringify(response.data.userData))
                if (to.path == '/') {
                    router.push({ path: '/ugyletek' })
                }
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    router.push({ path: '/login', query: { to: to.path } })
                }
            })
    }

    // if (to.meta.onlyAdmin) {
    //     axios.post('/api/auth/check')
    //         .then((response) => {
    //             console.log(response.data.user.type);
    //             if (response.data.user.type !== 'admin') {
    //                 router.push({ path: '/ugyletek' })
    //             }
    //         })
    //         .catch((error) => {
    //             if (error.response.status == 401) {
    //                 router.push({ path: '/login', query: { to: to.path } })
    //             }
    //         })
    // }

    return next()
        // Specify the current path as the customState parameter, meaning it
        // will be returned to the application after auth
        // auth.login({ target: to.path });


});

export default router